import { NgModule } from '@angular/core';
import { DecimalOnlyDirective } from './decimal-only.directive';

@NgModule({
    declarations: [DecimalOnlyDirective],
    exports: [DecimalOnlyDirective]
})
export class DecimalOnlyDirectiveModule {}
